import React, { useContext } from 'react';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import { GlobalState } from '@/containers/GlobalState';
import Imprint from "../../screens/settings/Imprint";
import TermsOfUse from "../../screens/settings/TermsOfUse";
import OpenSourceLicense from "../../screens/settings/OpenSourceLicense";
import DataSecurity from "../../screens/settings/DataSecurity";

import i18n from "i18n-js";


const Tab = createMaterialTopTabNavigator();

export default function LegalTabs() {
    const { inAColors } = useContext(GlobalState);

    return (
        <Tab.Navigator initialRouteName='imprint' screenOptions={{
            tabBarLabelStyle: { fontFamily: 'Assistant_400Regular', fontWeight: 400, fontSize: 20, color: inAColors.secondary[50], textTransform: 'none' },
            tabBarIndicatorStyle: { backgroundColor: inAColors.secondary[50] },
            tabBarStyle: { backgroundColor: inAColors.primary[900] },
            tabBarPressColor: inAColors.primary[700],
            tabBarPressOpacity: inAColors.primary[700]
        }}>
            <Tab.Screen name="imprint" options={{title: i18n.t('imprint.header')}}>
                {(props) => <Imprint {...props} hideFooter={true}/>}
            </Tab.Screen>
            <Tab.Screen name="tou" options={{title: i18n.t('tou.header')}}>
                {(props) => <TermsOfUse {...props} hideFooter={true}/>}
            </Tab.Screen>
            <Tab.Screen name="dpa" options={{title: i18n.t('dpa.header')}}>
                {(props) => <DataSecurity {...props} hideFooter={true}/>}
            </Tab.Screen>
            <Tab.Screen name="openSource" options={{title: i18n.t('osl.header')}}>
                {(props) => <OpenSourceLicense {...props} hideFooter={true}/>}
            </Tab.Screen>
        </Tab.Navigator>
    );
}
